import { Rater, RaterNoteData } from '../../../types/rater';
import DetailFormMethod from './DetailFormMethod';

export default DetailFormMethod;

export interface DetailFormMethodProps {
  notes?: RaterNoteData[];
  notesExpectation?: any;
  data: Rater[];
  title: string;
  type?: 'rater' | 'expectation';
}
